import HomeHeroBGSrc from "../assets/img/health-support/DCA_2222x1226.jpg";
import HomeHeroBGSrcTablet from "../assets/img/health-support/DCA_955x875.jpg";
import HomeHeroBGSrcMobile from "../assets/img/health-support/DCA_580x400.jpg";
import AppStore from "../assets/img/Gp27/Appstore.png";
import GooglePlay from "../assets/img/Gp27/Googleplay.png";
import TwentyFourMol from "../assets/img/Gp27/247mol.png";
import ClockMol from "../assets/img/Gp27/clockmol.png";
import MedicineMol from "../assets/img/Gp27/medicinemol.png";
import NumberOneMol from "../assets/img/Gp27/Rank1mol.png";
import TwentyFourHol from "../assets/img/Gp27/247Hol.png";
import ClockHol from "../assets/img/Gp27/clockhol.png";
import MedicineHol from "../assets/img/Gp27/medicineHol.png";
import NumberOneHol from "../assets/img/Gp27/rank1Hol.png";
import Physio from "../assets/img/Gp27/physio.png";
import PhysioMob from "../assets/img/Gp27/physio_mob.png";
import React from "react";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { Paths, Urls } from "./../constants/UrlConstants";
import { Link } from "react-router-dom";
import { ButtonConfig } from "../constants/Constants";
// import { RebrandHelper } from "../helpers/brand/RebrandHelper";

const GPAppointments247 = {


  EDCAHomeHeroBGSrc: {
    Any: HomeHeroBGSrc
  },
  EDCAHomeHeroBGSrcTablet: {
    Any: HomeHeroBGSrcTablet
  },
  EDCAHomeHeroBGSrcMobile: {
    Any: HomeHeroBGSrcMobile
  },
  EDCADescription: {
    Any: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service,
          available wherever and whenever you need it. <br />
          With a choice of appointments to see GPs or Advanced Clinical Practitioners for advice,
          prescriptions, or eligible specialist referrals,
          AXA Doctor at Hand takes care of things seamlessly.
        </p>
      </React.Fragment>
    )
  },

  LargeDescription: {
    Any: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service, available wherever
          and whenever you need it. <br />With a choice of appointments to see GPs or
          Advanced Clinical Practitioners for advice,  prescriptions,
          or eligible specialist referrals, AXA Doctor at Hand takes
          care of things seamlessly.<br />
          To find out if AXA Doctor at Hand is included as part of your cover, please check your membership documents and your membership handbook.
        </p>
      </React.Fragment>
    )
  },

  OthersDescription: {
    Any: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service, available wherever and whenever you need it.
          <br />With a choice of appointments to see GPs or Advanced Clinical Practitioners for advice, prescriptions, or eligible specialist
          referrals, AXA Doctor at Hand takes care of things seamlessly.
        </p>
      </React.Fragment>
    )
  },

  Importantinfo: <React.Fragment><b>Important information</b></React.Fragment>,
  ImportantNoteAvailabilityText: <React.Fragment><b>Availability</b> - Subject to appointment availability</React.Fragment>,
  ImportantNotePrescriptionsText: <React.Fragment><b>Prescriptions</b> - Prescriptions from AXA Doctor at Hand are available in most circumstances. Outpatient prescriptions and delivery are not covered by the scheme and may cost more than on the NHS. Prescriptions are only available in the UK.</React.Fragment>,
  ImportantNotereferralsText: <React.Fragment><b>Referrals to specialists</b> - Any outpatient limits or contributions you normally make towards treatment will apply. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are unable to refer to the NHS.</React.Fragment>,
  ImportantNotediagnosticsText: <React.Fragment><b>Referrals to diagnostics</b> - If included in your AXA Health scheme, where clinically and geographically appropriate (centres in England, Scotland and Wales). Diagnostic tests are subject to your scheme terms and conditions. Any outpatient limits or employee contribution normally made towards any treatment, will apply. Dependants must be aged 18+ for the GP or Advanced Clinical Practitioner to organise diagnostics.</React.Fragment>,

  OtherImportantNotediagnosticsText: <React.Fragment><p><b>Referrals to diagnostics</b> -  If included in your AXA Health scheme, where clinically and geographically appropriate (centres in England, Scotland and Wales). Diagnostic tests are subject to your scheme terms and conditions. Any outpatient limits will apply. Dependants must be aged 18+ for the GP or Advanced Clinical Practitioner to organise diagnostics. Not available on child only policies.</p></React.Fragment>,

  MolMoreService: {
    Appointment: <React.Fragment>
      <div className={layoutStyle.moredisplay}>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}>
            <img className={layoutStyle.imageSize} src={TwentyFourMol} alt="" aria-hidden />
          </div>
          <div className={layoutStyle.imgMorefloatright}>
            <b>Appointments available 24/7,<br />
              365 days a year</b>
          </div>
        </div>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}><img className={layoutStyle.imageSize} src={ClockMol} alt="" aria-hidden /></div>
          <div className={layoutStyle.imgMorefloatright}><b>Appointments are up to 20 minutes</b></div>
        </div>
      </div>
    </React.Fragment>,
    Prescriptions: <React.Fragment>
      <div className={layoutStyle.moredisplay}>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}>
            <img className={layoutStyle.imageSize} src={MedicineMol} alt="" aria-hidden />
          </div>
          <div className={layoutStyle.imgMorefloatright}>
            <b>Prescriptions delivered to your door</b>
          </div>
        </div>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}><img className={layoutStyle.imageSize} src={NumberOneMol} alt="" aria-hidden /></div>
          <div className={layoutStyle.imgMorefloatright}><b>Fully qualified GPs and Advanced Clinical<br /> Practitioners</b></div>
        </div>
      </div>
    </React.Fragment>,

  },



  HolMoreService: {
    Appointment: <React.Fragment>
      <div className={layoutStyle.moredisplay}>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}>
            <img className={layoutStyle.imageSize} src={TwentyFourHol} alt="" aria-hidden />
          </div>
          <div className={layoutStyle.imgMorefloatright}>
            <b>Appointments available 24/7,<br />
              365 days a year</b>
          </div>
        </div>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}><img className={layoutStyle.imageSize} src={ClockHol} alt="" aria-hidden /></div>
          <div className={layoutStyle.imgMorefloatright}><b>Appointments are up to 20 minutes</b></div>
        </div>
      </div>
    </React.Fragment>,
    Prescriptions: <React.Fragment>
      <div className={layoutStyle.moredisplay}>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}>
            <img className={layoutStyle.imageSize} src={MedicineHol} alt="" aria-hidden />
          </div>
          <div className={layoutStyle.imgMorefloatright}>
            <b>Prescriptions delivered to your door</b>
          </div>
        </div>
        <div className={layoutStyle.appDivMore}>
          <div className={layoutStyle.imgfloat}><img className={layoutStyle.imageSize} src={NumberOneHol} alt="" aria-hidden /></div>
          <div className={layoutStyle.imgMorefloatright}><b>Fully qualified GPs and Advanced Clinical<br /> Practitioners</b></div>
        </div>
      </div>
    </React.Fragment>,

  },


  PhysioSection: {
    IconSrc: Physio,
    IconSrcMobile: PhysioMob,
    Heading: "Seeking help for a muscle, bone or joint problem?",
    Description: (
      <React.Fragment>
        Get the help you need; we’ve made sure you can speak to an expert fast and without a GP referral. Available for members aged 18 and over.{" "}
        <br />

      </React.Fragment>
    ),
    LinkText: "MORE ABOUT THIS SERVICE",
    LinkTo: Urls.MSKBannerUrl,
    LinkHolTo: Urls.MSKBannerUrl,
    LinkMSKTo: Urls.MSKBannerUrl,
    IsNuffieldGym: false
  },
  // // PhysioSection:
  // // {
  // //   Physioimag: <div > <img className={layoutStyle.phsyioimage} src={Physio} alt="" aria-hidden /></div>,
  // //   PhysioHeaderText: <div><p> <b> Seeking help for a muscle, bone or joint problem?</b></p></div>,
  // //   PhysioText: <div><p>Get the help you need; we’ve made sure you can speak to an expert fast and without a GP referral. Available for members aged 18 and over.</p></div>,
  // //   PhysioMore: <div className={layoutStyle.phsyiomore}>
  // //     <a
  // //           className={layoutStyle.anchorDecorationUnderline}
  // //           href="https://www.axahealth.co.uk/personal-health/members/online-gp/"
  // //           target="_blank"
  // //           rel="noopener"
  // //         >MORE ABOUT THIS SERVICE
  // //         </a></div>,

  // },


  EDCAUsageNote: {
    Any: (
      <React.Fragment>
        <br />
        <ul style={{ listStyleType: "none", paddingInlineStart: "0" }}>
          <li>
            <sup>1</sup> Subject to appointment availability
          </li>
          <li>
            <p>
              <sup>2</sup> If you have healthcare cover, outpatient limits may
              apply. If you don't have healthcare cover any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. The GPs are unable to refer to
              the NHS.
            </p>
            <p>
              If you are referred on to treatment, please call us as a rolling
              cost share may be applicable.
            </p>
          </li>
        </ul>
      </React.Fragment>
    )
  },
  EDCAHelpSet: [
    {
      Question: "Can I use AXA Doctor at Hand from abroad?",
      Answer: {
        Any: (
          <p>
            Yes you can, they are available 24/7 365 days wherever you are in
            the world<sup>1</sup>.
          </p>
        )
      }
    },
    {
      Question: "Can I get a referral from AXA Doctor at Hand?",
      Answer: {
        Any: (
          <p>
            Yes, if you need to be referred to a specialist the GP will write a
            referral letter that can be passed directly to us for us to check
            you are covered on your plan, authorise your consultation, source
            appointments with the right specialist for your needs, and book the
            consultation for a time and place that suits you.<sup>2</sup>
          </p>
        )
      }
    }
  ],

  LargeCorporateHelpSet: [
    {
      Question: "Is AXA Doctor at Hand included as part of my scheme membership?",
      Answer: {
        Any: (
          <p>
            To find out if AXA Doctor at Hand is included as part of your cover,
            please check your membership documents and your membership handbook.
          </p>
        )
      }
    },
    {
      Question: "Can I get a prescription with AXA Doctor at Hand?",
      Answer: {
        Any: (
          <React.Fragment>
            <p>
              Yes. If a prescription could help, the clinician can organise prescriptions to be delivered straight to your office, home, or a local chemist if it’s easier.</p>
            <p>Prescriptions from AXA Doctor at Hand are available in most circumstances. Outpatient prescriptions and delivery are not covered by the scheme and may cost more than on the NHS. Prescriptions are only available in the UK.
            </p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can I use the service when I’m abroad?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>Yes, a member can have an appointment when abroad, however prescriptions are only available in the UK.</p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can the GP or Advanced Clinical Practitioner refer me to a specialist?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>If you have private healthcare benefits, including benefits for outpatient specialist consultations,  with AXA Health and the GP or Advanced Clinical Practitioner recommends that you should be referred to a specialist, we’ll check your benefits and then help book a consultation with a specialist at a time and place that’s convenient for you.
              We can also do this for your family members if they are included as part of your benefit.
              If you don’t have private healthcare benefits, any specialist referrals would need to be self-funded. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are not able to refer to the NHS.</p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can I add child dependants to my account?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>Yes, you can add anyone named on your scheme membership to your AXA Doctor at Hand account. You can also name up to two adults to act as a guardian to child dependants named on your account. These guardians should either be a parent or a legal guardian, who are over the age of 18.</p>
            <p>This means that in addition to the primary account holder, another nominated guardian who is a named member on the account will also be able to book and attend an appointment for the child with the GP or Advanced Clinical Practitioner. They will also be able to access medical records and notes, manage prescriptions and referrals for these dependants.</p>
          </React.Fragment>
        )
      }
    }
  ],

  IndiviualHelpSet: [
    {
      Question: "Can I get a prescription with AXA Doctor at Hand?",
      Answer: {
        Any: (
          <React.Fragment>
            <p>
              Yes. If a prescription could help, the clinician can organise one for you.
              You can choose for them to be delivered straight to your office, home, or a local chemist
              if it’s easier.
            </p>
            <p>Prescriptions are available in most circumstances.
              Outpatient prescriptions and delivery are not covered by
              the scheme and may cost more than on the NHS. Prescriptions are only available in the UK.
            </p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can I use the service when I’m abroad?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>Yes, a member can have an appointment when abroad, however prescriptions are only available in the UK.</p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can the GP or Advanced Clinical Practitioner refer me to a specialist?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>If you have private healthcare benefits with AXA Health and the GP or Advanced Clinical Practitioner recommends that you should be referred to a specialist, we’ll check your benefits and then help book a consultation with a specialist ata time and place that’s convenient for you.</p>
            <p>We can also do this for your family members if they are included as part of your benefit.
              If you don’t have private healthcare benefits, any specialist referrals would need to be self-funded. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are not able to refer to the NHS.</p>
          </React.Fragment>
        )
      }
    },
    {
      Question: 'Can I have more than one named guardian for my child dependant?',
      Answer: {
        Any: (
          <React.Fragment>
            <p>Yes you can, you can name up to two adults to act as a guardian to child dependants named on your account. These guardians should either be a parent or a legal guardian, who are over the age of 18.</p>
            <p>This means that in addition to the primary account holder, another nominated guardian will also be able to book and attend an appointment for the child with the GP or Advanced Clinical Practitioner. They will also be able to access medical records and notes, manage prescriptions and referrals for these dependants.</p>
          </React.Fragment>
        )
      }
    }
  ],
  OtherHeadeSet: [
    {
      Question: 'Can I get a prescription with AXA Doctor at Hand?',
      Answer: {
        Any: (<React.Fragment>
          <p>Yes. If a prescription could help, the clinician can organise one for you. You can choose for them to be delivered straight to your office, home, or a local chemist if it’s easier.
            Prescriptions are available in most circumstances. Outpatient prescriptions and delivery are not covered by the scheme and may cost more than on the NHS. Prescriptions are only available in the UK.</p>
        </React.Fragment>)
      }
    },
    {
      Question: 'Can I use the service when I’m abroad?',
      Answer: {
        Any: (<React.Fragment>
          <p>Yes, a member can have an appointment when abroad, however prescriptions are only available in the UK.</p>
        </React.Fragment>)
      }
    },
    {
      Question: 'Can the GP or Advanced Clinical Practitioner refer me to a specialist?',
      Answer: {
        Any: (<React.Fragment>
          <p>If you have private healthcare benefits with AXA Health and the GP or Advanced Clinical Practitioner recommends that you should be referred to a specialist, we’ll check your benefits and then help book a consultation with a specialist ata time and place that’s convenient for you.</p>
          <p>We can also do this for your family members if they are included as part of your benefit.
            If you don’t have private healthcare benefits, any specialist referrals would need to be self-funded. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are not able to refer to the NHS.</p>
        </React.Fragment>)
      }
    },
    {
      Question: 'Can I have more than one named guardian for my child dependant?',
      Answer: {
        Any: (
          <React.Fragment> <p>Yes you can, you can name up to two adults to act as a guardian to child dependants named on your account. These guardians should either be a parent or a legal guardian, who are over the age of 18.
          </p>
            <p>This means that in addition to the primary account holder, another nominated guardian will also be able to book and attend an appointment for the child with the GP or Advanced Clinical Practitioner. They will also be able to access medical records and notes, manage prescriptions and referrals for these dependants.</p></React.Fragment>
        )
      }
    }


  ],
  HelpSet: [
    {
      Question: "Is AXA Doctor at Hand included as part of my scheme membership?",
      Answer: {
        LargeCorporate: (
          <p>
            To find out if AXA Doctor at Hand is included as part of your cover,
            please check your membership documents and your membership handbook.
          </p>
        ),
        SME: (
          <p>
            Yes, unlimited access to AXA Doctor at Hand is included as part of
            your membership with us.
          </p>
        ),
        SMEModular: (
          <p>
            Yes, unlimited access to AXA Doctor at Hand is included as part of
            your membership with us.
          </p>
        ),
        HOL: (
          <React.Fragment>
            <p>
              AXA Doctor at Hand is not part of your policy but this service is
              currently being offered to you at no extra cost. It will not
              affect any excess or no claims discount you may have on your
              policy. Please see the{" "}
              <a
                className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                href={Urls.AXASMEDAH}
                target="_blank"
                rel="noopener noreferrer"
              >
                terms and conditions
              </a>{" "}
              for more information.
            </p>
          </React.Fragment>
        ),
        Any: (
          <React.Fragment>
            <p>
              Yes. If a prescription could help, the clinician can organise one for you. You can choose for them to be delivered straight to your office, home, or a local chemist if it’s easier.
              Prescriptions are available in most circumstances. Outpatient prescriptions and delivery are not covered by the scheme and may cost more than on the NHS. Prescriptions are only available in the UK..
            </p>
          </React.Fragment>
        )
      }
    },
    {
      Question: "Can I get a prescription with AXA Doctor at Hand??",
      Answer: {
        LargeCorporate: (
          <p>
            Yes. If a prescription could help, the clinician can organise prescriptions to be delivered straight to your office, home, or a local chemist if it’s easier.
            Prescriptions from AXA Doctor at Hand are available in most circumstances. Outpatient prescriptions and delivery are not covered by the scheme and may cost more than on the NHS.
            Prescriptions are only available in the UK.
          </p>
        ),
        Any: (
          <p>
            Yes, a member can have an appointment when abroad, however prescriptions are only available in the UK.
          </p>
        )
      }
    },
    {
      Question: "Can I use the service when I’m abroad?",
      Answer: {
        SMEModular: {
          HOL: (
            <p>
              Yes, if you need to be referred to a specialist the doctor will
              write a referral letter that can be passed directly to us to check
              your policy cover. If you're covered, we will authorise your
              consultation, source an appointment with the right specialist for
              your needs, and book the consultation for a time and place that
              suits you. Depending on the level of cover you have chosen,
              outpatient limits may apply. If your policy does not include
              outpatient specialist consultations, any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. Doctor Care Anywhere GPs are
              unable to refer to the NHS.
            </p>
          ),
          Any: (
            <p>
              If you have private healthcare benefits with AXA Health and the GP or Advanced Clinical Practitioner recommends that you should be referred to a specialist, we’ll check your benefits and then help book a consultation with a specialist ata time and place that’s convenient for you.
              We can also do this for your family members if they are included as part of your benefit.
              If you don’t have private healthcare benefits, any specialist referrals would need to be self-funded. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are not able to refer to the NHS..
            </p>
          )
        },
        LargeCorporate: (
          <p>
            Yes, a member can have an appointment when abroad,
            however prescriptions are only available in the UK.          </p>
        ),
        HOL: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your policy, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your policy does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        ),
        Any: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your plan, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your plan does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        )
      }
    },
    {
      Question: "Can the GP or Advanced Clinical Practitioner refer me to a specialist?",
      Answer: {
        SMEModular: {
          HOL: (
            <p>
              Yes, if you need to be referred to a specialist the doctor will
              write a referral letter that can be passed directly to us to check
              your policy cover. If you're covered, we will authorise your
              consultation, source an appointment with the right specialist for
              your needs, and book the consultation for a time and place that
              suits you. Depending on the level of cover you have chosen,
              outpatient limits may apply. If your policy does not include
              outpatient specialist consultations, any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. Doctor Care Anywhere GPs are
              unable to refer to the NHS.
            </p>
          ),
          Any: (
            <p>
              Yes, if you need to be referred to a specialist the doctor will
              write a referral letter that can be passed directly to us to check
              your plan cover. If you're covered, we will authorise your
              consultation, source an appointment with the right specialist for
              your needs, and book the consultation for a time and place that
              suits you. Depending on the level of cover you have chosen,
              outpatient limits may apply. If your plan does not include
              outpatient specialist consultations, any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. Doctor Care Anywhere GPs are
              unable to refer to the NHS.
            </p>
          )
        },
        LargeCorporate: (
          <p>
            If you have private healthcare benefits, including benefits for outpatient specialist consultations,  with AXA Health and the GP or Advanced Clinical Practitioner recommends that you should be referred to a specialist, we’ll check your benefits and then help book a consultation with a specialist at a time and place that’s convenient for you.
            We can also do this for your family members if they are included as part of your benefit.
            If you don’t have private healthcare benefits, any specialist referrals would need to be self-funded. All referrals and treatment recommended are on a private basis. The GPs and Advanced Clinical Practitioners are not able to refer to the NHS.
          </p>
        ),
        HOL: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your policy, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your policy does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        ),
        Any: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your plan, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your plan does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        )
      }
    },
    {
      Question: "Can I add child dependants to my account?",
      Answer: {
        SMEModular: {
          HOL: (
            <p>
              Yes, if you need to be referred to a specialist the doctor will
              write a referral letter that can be passed directly to us to check
              your policy cover. If you're covered, we will authorise your
              consultation, source an appointment with the right specialist for
              your needs, and book the consultation for a time and place that
              suits you. Depending on the level of cover you have chosen,
              outpatient limits may apply. If your policy does not include
              outpatient specialist consultations, any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. Doctor Care Anywhere GPs are
              unable to refer to the NHS.
            </p>
          ),
          Any: (
            <p>
              Yes, if you need to be referred to a specialist the doctor will
              write a referral letter that can be passed directly to us to check
              your plan cover. If you're covered, we will authorise your
              consultation, source an appointment with the right specialist for
              your needs, and book the consultation for a time and place that
              suits you. Depending on the level of cover you have chosen,
              outpatient limits may apply. If your plan does not include
              outpatient specialist consultations, any specialist referrals
              would need to be self-funded. All referrals and treatment
              recommended are on a private basis. Doctor Care Anywhere GPs are
              unable to refer to the NHS.
            </p>
          )
        },
        LargeCorporate: (
          <React.Fragment>
            <p>
              Yes, you can add anyone named on your scheme membership to your AXA Doctor at Hand account. You can also name up to two adults to act as a guardian to child dependants named on your account. These guardians should either be a parent or a legal guardian, who are over the age of 18.</p>
            <p>This means that in addition to the primary account holder, another nominated guardian who is a named member on the account will also be able to book and attend an appointment for the child with the GP or Advanced Clinical Practitioner. They will also be able to access medical records and notes, manage prescriptions and referrals for these dependants.</p>
          </React.Fragment>
        ),
        HOL: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your policy, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your policy does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        ),
        Any: (
          <p>
            Yes, if you need to be referred to a specialist the GP can write a
            referral letter that can be passed directly to us. We will then
            check you are covered on your plan, authorise your consultation,
            source an appointment with the right specialist for your needs, and
            book the consultation for a time and place that suits you. Depending
            on the level of cover you have chosen, outpatient limits may apply.
            If your plan does not include outpatient specialist consultations,
            any specialist referrals would need to be self-funded. All referrals
            and treatment recommended are on a private basis. Doctor Care
            Anywhere GPs are unable to refer to the NHS.
          </p>
        )
      }
    }
  ],
  HomeHeroBGSrc: {
    Any: HomeHeroBGSrc
  },
  HomeHeroBGSrcTablet: {
    Any: HomeHeroBGSrcTablet
  },
  HomeHeroBGSrcMobile: {
    Any: HomeHeroBGSrcMobile
  },
  Heading: {
    Any: " A fast, easy way to see a GP"
  },
  Setupthisservice: "SET UP THE SERVICE",
  BookanAppointment: "BOOK AN APPOINTMENT",


  Description: {
    SMEModular: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service,
          available wherever and whenever you need it. <br />
          With a choice of appointments to see GPs or Advanced Clinical Practitioners for advice,
          prescriptions, or eligible specialist referrals, AXA Doctor at Hand
          takes care of things seamlessly.
        </p>
      </React.Fragment>
    ),
    LargeCorporate: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service,
          available wherever and whenever you need it.
          <br />
          With a choice of appointments to see GPs
          or Advanced Clinical Practitioners for advice,
          prescriptions, or eligible specialist referrals,
          AXA Doctor at Hand takes care of things seamlessly.<br />
          To find out if AXA Doctor at Hand is included as part of your cover, please check your membership documents and your membership handbook.
        </p>

      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service,
          available wherever and whenever you need it. <br />
          With a choice of appointments to see GPs
          or Advanced Clinical Practitioners for advice, prescriptions, or eligible specialist referrals, AXA Doctor at Hand takes care of things seamlessly..
        </p>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        <p>
          AXA Doctor at Hand, powered by Doctor Care Anywhere, is a 24/7 service,
          available wherever and whenever you need it.  <br />
          With a choice of appointments to see GPs or Advanced Clinical Practitioners for advice,
          prescriptions, or eligible specialist referrals, AXA Doctor at Hand takes care of things
          seamlessly.
        </p>
      </React.Fragment>
    )
  },
  ButtonText: {
    LargeCorporate: "Find out more",
    SMEModular: "Find out more",
    Any: ""
  },
  ExternalLinkTo: {
    LargeCorporate:
      "https://doctorcareanywhere.com/axamembership",
    SMEModular: {
      HOL: Urls.DCAMembersHOL,
      Any: Urls.DCAMembersAXA
    },
    Any: ""
  },

  HowToRegisterHeading: "How to register",
  HowToRegisterSection: {
    SMEModular: {
      Any: (
        <React.Fragment>
          <p>
            To start using your online GP service included as part of your
            membership with us:
          </p>
          <ol>
            <li>
              You'll need to have some photo ID and your membership number to
              hand to register. You'll find your membership number{" "}
              <Link
                className={layoutStyle.anchorDecorationUnderline}
                to={Paths.Cover}
              >
                here
              </Link>
              .
            </li>
            <li>
              Go to{" "}
              <a
                className={layoutStyle.anchorDecorationUnderline}
                href={Urls.DCAMembersAXA}
                target="_blank"
                rel="noopener noreferrer"
              >
                Doctor Care Anywhere
              </a>{" "}
              and follow the activation steps.
            </li>
          </ol>
          <p>
            <strong>Please note:</strong> The lead member will need to activate
            their AXA Doctor at Hand account and then add any family members who
            are covered on the plan.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            To start using your online GP service included as part of your
            membership with us:
          </p>
          <ol>
            <li>
              You'll need to have some photo ID and your membership number to
              hand to register. You'll find your membership number{" "}
              <Link
                className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                to={Paths.Cover}
              >
                here
              </Link>
              .
            </li>
            <li>
              Go to{" "}
              <a
                className={"hol-link " + layoutStyle.anchorDecorationUnderline}
                href={Urls.DCAMembersHOL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Doctor Care Anywhere
              </a>{" "}
              and follow the activation steps.
            </li>
          </ol>
          <p>
            <strong>Please note:</strong> The lead member will need to activate
            their AXA Doctor at Hand account and then add any family members who
            are covered on the policy.
          </p>
        </React.Fragment>
      )
    },
    HOL: (
      <React.Fragment>
        <ol>
          <li>
            You'll need to have some photo ID and your membership number to hand
            to register. You'll find your membership number{" "}
            <Link
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              to={Paths.CoverDocuments}
            >
              here
            </Link>
            .
          </li>
          <li>
            Go to{" "}
            <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={Urls.DCAMembersSignup}
              target="_blank"
              rel="noopener noreferrer"
            >
              Doctor Care Anywhere
            </a>{" "}
            and follow the activation steps.
          </li>
        </ol>
        <p>
          <strong>Please note:</strong> The lead member will need to activate
          their AXA Doctor at Hand account and then add any family members who
          are covered on the policy. Please enter names and addresses of members
          exactly as they appear on your membership certificate. Please do not
          shorten names or add members who are not covered by your policy.
        </p>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        <ol>
          <li>
            You'll need to have some photo ID and your membership number to hand
            to register. You'll find your membership number{" "}
            <Link
              className={layoutStyle.anchorDecorationUnderline}
              to={Paths.CoverDocuments}
            >
              here
            </Link>
            .
          </li>
          <li>
            Go to{" "}
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href={Urls.DCAMembersSignup}
              target="_blank"
              rel="noopener noreferrer"
            >
              Doctor Care Anywhere
            </a>{" "}
            and follow the activation steps.
          </li>
        </ol>
        <p>
          <strong>Please note:</strong> The lead member will need to activate
          their AXA Doctor at Hand account and then add any family members who
          are covered on the plan. Please enter names and addresses of members
          exactly as they appear on your membership certificate. Please do not
          shorten names or add members who are not covered by your plan.
        </p>
      </React.Fragment>
    )
  },

  HowItWorksSectionSubheading: "How it works",

  LargeHowItWorksContent: {
    Any: (
      <React.Fragment>
        <p>
          Register today so your account is ready to go when you need it.
          Once you’ve registered, you can book an online appointment with a GP or
          Advanced Clinical Practitioner.
        </p>
        <p>
          Go to{" "}
          <a
            id={ButtonConfig.DocterAtAnywhere}
            className={layoutStyle.anchorDecorationUnderline}
            href="https://doctorcareanywhere.com"
            target="_blank"
            rel="noopener"
          >
            doctorcareanywhere.com
          </a>{" "}
          or use the handy <b>AXA Doctor at Hand app.</b>
        </p>
        <p><b>Download the app</b></p>
        <div className={layoutStyle.appDiv}>
          <div className={layoutStyle.imgfloat}>
            <a
            id={ButtonConfig.AppStore}
            className={layoutStyle.anchorDecorationUnderline}
            href="https://apps.apple.com/gb/app/axa-doctor-at-hand/id1536116883"
            target="_blank"
            rel="noopener"
          >
            <img src={AppStore} alt="" aria-hidden />
          </a></div>
          <div className={layoutStyle.imgfloatright}>
            <a
            id={ButtonConfig.GooglePlay}
              className={layoutStyle.anchorDecorationUnderline}
              
              href="https://play.google.com/store/apps/details?id=com.axa.doctorathand&hl=en&gl=US"
              target="_blank"
              rel="noopener"
            >
              <img src={GooglePlay} alt="" aria-hidden />
            </a></div>
        </div>
        <p>There’s no need to fit in with fixed opening hours or be left hanging
          on the phone to make an appointment or to get the support you need.</p>
        <ul>
          <li>GPs are available <b>24/7</b></li>
          <li>Advanced Clinical Practitioners are available from <b>8am to 10pm.</b></li>
        </ul>
        <p>
          <a
          id={ButtonConfig.MoreAboutService}
            className={layoutStyle.anchorDecorationUnderline}
            href="https://www.axahealth.co.uk/business/products/corporate-health-insurance/workplace-online-gp/"
            target="_blank"
            rel="noopener"
          >
            More about this service
          </a>
        </p>
      </React.Fragment>
    )
  },

  OthersHowItWorksContent: {
    Any: (
      <React.Fragment>
        <p>Register today so your account is ready to go when you need it. Once you’ve registered,
          you can book an online appointment with a GP or Advanced Clinical Practitioner. </p>
        <ol typee="1">
          <li>
            Go to{" "}
            <a
            id={ButtonConfig.DocterAtAnywhere}
              className={layoutStyle.anchorDecorationUnderline}
              href="https://doctorcareanywhere.com"
              target="_blank"
              rel="noopener"
            >
              doctorcareanywhere.com
            </a>{" "}
            or use the handy <b>AXA Doctor at Hand app.</b>
          </li>
          <li>Enter your AXA Health membership number as the authorisation code and set up your account.</li>
          <li>Confirm your date of birth, add a password and mobile number.</li>
        </ol>
        <p>
          Your account has been activated!
        </p>
        <p><b>Download the app</b></p>
        <div className={layoutStyle.appDiv}>
          <div className={layoutStyle.imgfloat}>
            <a
              id={ButtonConfig.AppStore}
              className={layoutStyle.anchorDecorationUnderline}
              href="https://apps.apple.com/gb/app/axa-doctor-at-hand/id1536116883"
              target="_blank"
              rel="noopener"
            >
              <img src={AppStore} alt="" aria-hidden />
            </a>
          </div>
          <div className={layoutStyle.imgfloatright}>
            <a
              id={ButtonConfig.GooglePlay}
              className={layoutStyle.anchorDecorationUnderline}
              href="https://play.google.com/store/apps/details?id=com.axa.doctorathand&hl=en&gl=US"
              target="_blank"
              rel="noopener"
            >
              <img src={GooglePlay} alt="" aria-hidden />
            </a></div>
        </div>
        <p>
          There’s no need to fit in with fixed opening hours or be left hanging on the phone to make an appointment or to get the support you need.
        </p>
        <ul>
          <li>GPs are available <b>24/7</b></li>
          <li>Advanced Clinical Practitioners are available from <b>8am to 10pm.</b> </li>
        </ul>
        <p>
          <a
            className={layoutStyle.anchorDecorationUnderline}
            id={ButtonConfig.MoreAboutService}
            href="https://www.axahealth.co.uk/personal-health/members/online-gp/"
            target="_blank"
            rel="noopener"
          >
            More about this service
          </a>
        </p>
      </React.Fragment>
    )
  },

  HowItWorksSectionList: {
    LargeCorporate: (
      <React.Fragment>
        <p>
          Register today so your account is ready to go when you need it.
          Once you’ve registered, you can book an online appointment with a GP or
          Advanced Clinical Practitioner.
        </p>
        <p>
          Go to{" "}
          <a
            className={layoutStyle.anchorDecorationUnderline}
            href="https://doctorcareanywhere.com"
            target="_blank"
            rel="noopener"
          >
            doctorcareanywhere.com
          </a>{" "}
          or use the handy <b>AXA Doctor at Hand app.</b>
        </p>
        <p><b>Download the app</b></p>
        <div className={layoutStyle.appDiv}>
          <div className={layoutStyle.imgfloat}><img src={AppStore} alt="" aria-hidden /></div>
          <div className={layoutStyle.imgfloatright}><img src={GooglePlay} alt="" aria-hidden /></div>
        </div>
        <p>There’s no need to fit in with fixed opening hours or be left hanging
          on the phone to make an appointment or to get the support you need.</p>
        <ul>
          <li>GPs are available <b>24/7</b></li>
          <li>Advanced Clinical Practitioners are available from <b>8am to 10pm.</b></li>
        </ul>
        <p>
          <a
            className={layoutStyle.anchorDecorationUnderline}
            href="https://www.axahealth.co.uk/personal-health/members/online-gp/"
            target="_blank"
            rel="noopener"
          >
            More about this service
          </a>
        </p>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        <p>Register today so your account is ready to go when you need it. Once you’ve registered,
          you can book an online appointment with a GP or Advanced Clinical Practitioner. </p>
        <ol typee="1">
          <li>
            Go to{" "}
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href="https://doctorcareanywhere.com"
              target="_blank"
              rel="noopener"
            >
              doctorcareanywhere.com
            </a>{" "}
            or use the handy <b>AXA Doctor at Hand app.</b>
          </li>
          <li>Enter your AXA Health membership number as the authorisation code and set up your account.</li>
          <li>Confirm your date of birth, add a password and mobile number.</li>
        </ol>
        <p>
          Your account has been activated!
        </p>
        <p><b>Download the app</b></p>
        <div className={layoutStyle.appDiv}>
          <div className={layoutStyle.imgfloat}>
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href="https://apps.apple.com/gb/app/axa-doctor-at-hand/id1536116883"
              target="_blank"
              rel="noopener"
            >
              <img src={AppStore} alt="" aria-hidden />
            </a>
          </div>
          <div className={layoutStyle.imgfloatright}>
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href="https://play.google.com/store/apps/details?id=com.axa.doctorathand&hl=en&gl=US"
              target="_blank"
              rel="noopener"
            >
              <img src={GooglePlay} alt="" aria-hidden />
            </a></div>
        </div>
        <p>
          There’s no need to fit in with fixed opening hours or be left hanging on the phone to make an appointment or to get the support you need.
        </p>
        <ul>
          <li>GPs are available <b>24/7</b></li>
          <li>Advanced Clinical Practitioners are available from <b>8am to 10pm.</b> </li>
        </ul>
        <p>
          <a
            className={layoutStyle.anchorDecorationUnderline}
            href="https://www.axahealth.co.uk/personal-health/members/online-gp/"
            target="_blank"
            rel="noopener"
          >
            More about this service
          </a>
        </p>
      </React.Fragment>
    )
  },
  HowItWorksFindOutMore: {
    LargeCorporate: (
      <React.Fragment>
        <p>
          Find out more information{" "}
          <a
            className={layoutStyle.anchorDecorationUnderline}
            href="https://doctorcareanywhere.com/axamembership"
            target="_blank"
            rel="noopener"
          >
            here
          </a>
          .
        </p>
      </React.Fragment>
    ),
    SMEModular: {
      HOL: (
        <React.Fragment>
          {/* <p>
            Find out more information{" "}
            <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={Urls.DCAMembersHOL}
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </p> */}
        </React.Fragment>
      ),
      Any: (
        <React.Fragment>
          <p>
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href={Urls.DCAVideoLinkAxa}
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch the video
            </a>{" "}
            or click{" "}
            <a
              className={layoutStyle.anchorDecorationUnderline}
              href={Urls.DCAMembersAXA}
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            to find out more about AXA Doctor at Hand.
          </p>
        </React.Fragment>
      )
    },
    HOL: (
      <p>
        By activating and using this service you are accepting the{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.AXASMEDAH}
          target="_blank"
          rel="noopener noreferrer"
        >
          terms and conditions specific to this offer
        </a>{" "}
        and also the{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.DCATandC}
          target="_blank"
          rel="noopener noreferrer"
        >
          main terms and conditions
        </a>{" "}
        and{" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.DCAPrivacy}
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy policy
        </a>{" "}
        relating to the Doctor Care Anywhere service.
      </p>
    ),
    Any: (
      <p>
        By activating and using this service you are accepting the{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.AXASMEDAH}
          target="_blank"
          rel="noopener noreferrer"
        >
          terms and conditions specific to this offer
        </a>{" "}
        and also the{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.DCATandC}
          target="_blank"
          rel="noopener noreferrer"
        >
          main terms and conditions
        </a>{" "}
        and{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.DCAPrivacy}
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy policy
        </a>{" "}
        relating to the Doctor Care Anywhere service.
        <br />
        <br />
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.DCAVideoLinkAxa}
          target="_blank"
          rel="noopener noreferrer"
        >
          Watch the video
        </a>{" "}
        to find out more about AXA Doctor at Hand.
      </p>
    )
  },
  EDCAHowItWorksContent: {
    Any: (
      <React.Fragment>
        <p>
          Register today so your account is ready to go when you need it.
          Once you’ve registered, you can book an online appointment with a GP or
          Advanced Clinical Practitioner.
        </p>
        <ol typee="1">
          <li> <p>
            Sign up on the{" "}
            <a
              id={ButtonConfig.EDCABarcalys}
              className={layoutStyle.anchorDecorationUnderline}
              href="https://doctorcareanywhere.com/barclays/"
              target="_blank"
              rel="noopener"
            >
              Barclays AXA Doctor at Hand website
            </a>
            or download the App
          </p></li>
          <li>Use your BRID to register.</li>
          <li>Book your video or telephone appointment</li>
        </ol>
        <p><b>Available to Barclays colleagues and their eligible dependants</b></p>
        <p><b>Download the app</b></p>
        <div className={layoutStyle.appDiv}>
          <div className={layoutStyle.imgfloat}>
          <a
            id={ButtonConfig.AppStore}
            className={layoutStyle.anchorDecorationUnderline}
            href="https://apps.apple.com/gb/app/axa-doctor-at-hand/id1536116883"
            target="_blank"
            rel="noopener"
          >
            <img src={AppStore} alt="" aria-hidden />
            </a>
          </div>
          <div className={layoutStyle.imgfloatright}>
          <a
            id={ButtonConfig.GooglePlay}
              className={layoutStyle.anchorDecorationUnderline}
              
              href="https://play.google.com/store/apps/details?id=com.axa.doctorathand&hl=en&gl=US"
              target="_blank"
              rel="noopener"
            >
              <img src={GooglePlay} alt="" aria-hidden />
            </a>
          </div>
        </div>
        <p>There’s no need to fit in with fixed opening hours or be left hanging
          on the phone to make an appointment or to get the support you need.</p>
        <ul>
          <li>GPs are available <b>24/7</b></li>
          <li>Advanced Clinical Practitioners are available from <b>8am to 10pm.</b></li>
        </ul>
        <p>
          If the GP or Advanced Clinical Practitioner thinks that a face to face appointment
          is appropriate,  they can refer you for a private GP consultation at specified
          Nuffield Health centres across London, Glasgow and Edinburgh, including on-site at
          1 Churchill place.
        </p>
        <p>
          <a
            className={layoutStyle.anchorDecorationUnderline}
            href="https://www.axahealth.co.uk/personal-health/members/online-gp/"
            target="_blank"
            rel="noopener"
          >
            More about this service
          </a>
        </p>
      </React.Fragment>
    )
  }
};

export default GPAppointments247;
